export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
              <i className="ri-hand-heart-line"></i>
              关于我们
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
              一个只聊心动、不谈套路的地方
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              羞羞的动漫是一群爱磕糖、爱纯爱、也爱暧昧拉扯的追番同好，一起搭起来的内容站。我们相信好的恋爱番能让心变软，也想把这份心动分享给更多人。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              我们坚持内容的原创与真诚：不做标题党，不堆关键词，只把真正值得看的甜番整理成合集，配上用心的甜度测评与心动名场面，让每一次点开都值得。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
                <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-pen-nib-line text-lg"></i>
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-950">内容原则</h3>
                <p className="mt-1.5 text-sm text-foreground-600">原创文案、真实测评，不搬运、不洗稿。</p>
              </div>
              <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
                <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-compass-3-line text-lg"></i>
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-950">持续更新</h3>
                <p className="mt-1.5 text-sm text-foreground-600">每周补充新番，榜单与合集同步刷新。</p>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-3 text-sm">
              <span className="inline-flex items-center gap-2 px-3 py-2 text-foreground-600 bg-background-100 rounded-md">
                <i className="ri-mail-line text-primary-600"></i>
                hello@xiuxiudongman.com
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-2 text-foreground-600 bg-background-100 rounded-md">
                <i className="ri-time-line text-primary-600"></i>
                每周三更新推荐合集
              </span>
            </div>
          </div>

          <div className="rounded-lg overflow-hidden border border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20two%20friends%20sitting%20on%20a%20couch%20watching%20anime%20together%20with%20snacks%20and%20warm%20tea%2C%20cozy%20living%20room%20with%20soft%20golden%20lamp%20light%2C%20cherry%20blossom%20and%20heart%20decorations%2C%20pink%20and%20peach%20color%20palette%2C%20comfortable%20relaxed%20warm%20atmosphere%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=900&seq=about-illustration&orientation=portrait"
              alt="追番同好一起看恋爱甜番的温馨插画"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}